import Vue from 'vue'

var VueCookie = require('vue-cookie')
Vue.use(VueCookie)
